module.exports = __webpack_public_path__ + "static/media/vviGraphSlotMap.1d05fbc6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/vviGraphSlotMap.svg
// module id = 995
// module chunks = 0